import { render } from "./SelectBank.vue?vue&type=template&id=6275e004&scoped=true"
import script from "./SelectBank.vue?vue&type=script&lang=js"
export * from "./SelectBank.vue?vue&type=script&lang=js"

import "./SelectBank.vue?vue&type=style&index=0&id=6275e004&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6275e004"]])

export default __exports__